<template>
  <div class="pressure-detection">
    <div class="header-row">
      <div class="title-section">
        <img src="@/assets/gisWork/SVG/title-bg.svg" class="title-bg" />
        <span class="title-text">压力监测</span>
      </div>
    </div>

    <!-- 选择区域和状态按钮 -->
    <div class="selection-row">
      <div class="left-controls">
        <a-date-picker show-time placeholder="选择时间" @ok="onOk" @change="onTimeChange" style="width: 200px;"
          allow-clear />
        <a-tree-select :tree-data="zoneTreeData" v-model="zoneName" style="width: 195px; margin-left: 10px;"
          :replace-fields="{ title: 'zoneName', key: 'id', value: 'zoneName', selectable: 'selectable' }"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
          tree-default-expand-all @change="treeDataChange" />
      </div>
      <div class="right-buttons">
        <div class="hex-button" :class="{ active: selectedStatus === '正常' }" @click="selectStatus('正常')">
          <img :src="selectedStatus === '正常' ? activeIcon : inactiveIcon" class="button-bg" />
          <span>正常 {{ obj.normalCount }}</span>
        </div>
        <div class="hex-button" :class="{ active: selectedStatus === '采集异常' }" @click="selectStatus('采集异常')">
          <img :src="selectedStatus === '采集异常' ? activeIcon : inactiveIcon" class="button-bg" />
          <span>异常 {{ obj.abnormalCount }}</span>
        </div>
        <div class="hex-button" :class="{ active: selectedStatus === '高压' }" @click="selectStatus('高压')">
          <img :src="selectedStatus === '高压' ? activeIcon : inactiveIcon" class="button-bg" />
          <span>高压 {{ obj.highPressureCount }}</span>
        </div>
        <div class="hex-button" :class="{ active: selectedStatus === '低压' }" @click="selectStatus('低压')">
          <img :src="selectedStatus === '低压' ? activeIcon : inactiveIcon" class="button-bg" />
          <span>低压 {{ obj.lowPressureCount }}</span>
        </div>
      </div>
    </div>

    <!-- 数据卡片区域 -->
    <div class="data-cards-section">
      <a-spin :spinning="loading" tip="数据加载中...">
        <div class="drag-sort-btn">
          <div class="hex-button sort-button" :class="{ active: isSorting }" @click="toggleSort">
            <img :src="isSorting ? activeIcon : inactiveIcon" class="button-bg" />
            <span>拖动排序</span>
          </div>
        </div>
        <draggable v-model="dataList" :disabled="!isSorting" class="cards-grid" animation="300" @end="onDragEnd">
          <div class="data-card" v-for="(item, index) in dataList" :key="index">
            <div class="card-top">
              <div class="card-time">{{ item.collectTime }}</div>
              <div class="card-elevation">高程: {{ item.groundElevation }}</div>
              <div v-if="item.status === '高压'" class="warning-text">+{{ item.abnormalValue }}↑</div>
            </div>
            <div class="card-value" v-if="item.status === '采集异常'">
              <span class="error-text">采集异常</span>
            </div>
            <div class="card-value" v-else :class="getValueClass(item)">
              <span class="value-number">{{ item.piezometerValue }}</span>
              <span class="value-unit">Mpa</span>
            </div>
            <div class="card-bottom">
              <div class="card-location">
                <img src="@/assets/myImg/1/icon-位置.png" class="location-icon" />
                <span>{{ item.address }}</span>
              </div>
            </div>
          </div>
        </draggable>
      </a-spin>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import draggable from 'vuedraggable'

export default {
  name: 'PressureDetection',
  components: {
    draggable,
  },
  data () {
    return {
      zoneName: null,
      zoneNames: [], // 存储选中片区及其所有子片区
      zoneTreeData: [], // 片区选项
      queryZoneDateUrl: 'zone-metering/zone-metering',
      selectCollectTime: '',
      selectedStatus: '',
      isSorting: false,
      loading: false,
      // SVG图标路径
      activeIcon: require('@/assets/pressure/u101.svg'),
      inactiveIcon: require('@/assets/pressure/u104.svg'),
      obj: {
        normalCount: 0,
        abnormalCount: 0,
        highPressureCount: 0,
        lowPressureCount: 0
      },
      dataList: [],
      allDataList: [] // 保存完整的数据列表用于前端过滤
    }
  },
  created () {
    this.getZoneData()
    this.fetchData()
  },
  methods: {
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    treeDataChange (item) {
      if (item) {
        // 获取选中片区及其所有子片区
        this.zoneNames = this.getAllZoneNames(item, this.zoneTreeData)
      } else {
        this.zoneNames = []
      }
      // 重置状态筛选
      this.selectedStatus = ''
      this.fetchData()
    },
    // 递归获取选中片区及其所有子片区的名称
    getAllZoneNames (selectedZoneName, treeData) {
      const zoneNames = []

      // 递归查找选中的节点
      const findNode = (nodes, targetName) => {
        for (let node of nodes) {
          if (node.zoneName === targetName) {
            return node
          }
          if (node.children && node.children.length > 0) {
            const found = findNode(node.children, targetName)
            if (found) return found
          }
        }
        return null
      }

      // 递归获取所有子片区名称
      const collectZoneNames = (node) => {
        if (!node) return
        zoneNames.push(node.zoneName)
        if (node.children && node.children.length > 0) {
          node.children.forEach(child => {
            collectZoneNames(child)
          })
        }
      }

      const selectedNode = findNode(treeData, selectedZoneName)
      collectZoneNames(selectedNode)

      return zoneNames
    },
    onOk (date) {
      if (date !== '') {
        this.selectCollectTime = moment(date).format('x')
      } else {
        this.selectCollectTime = ''
      }
      // 重置状态筛选
      this.selectedStatus = ''
      this.fetchData()
    },
    onTimeChange (date) {
      // 处理时间变化，包括清空的情况
      if (date) {
        this.selectCollectTime = moment(date).format('x')
      } else {
        this.selectCollectTime = ''
      }
      // 重置状态筛选
      this.selectedStatus = ''
      this.fetchData()
    },
    selectStatus (status) {
      // 如果点击的是当前选中的状态，则取消选中
      if (this.selectedStatus === status) {
        this.selectedStatus = ''
      } else {
        this.selectedStatus = status
        // 选择状态筛选时，关闭排序模式
        if (this.isSorting) {
          this.isSorting = false
        }
      }
      // 前端过滤数据，不重新查询
      this.filterDataByStatus()
    },
    filterDataByStatus () {
      // 根据选中的状态过滤数据
      if (this.selectedStatus === '') {
        // 未选中状态，显示全部数据
        this.dataList = [...this.allDataList]
      } else {
        // 根据 status 字段过滤
        this.dataList = this.allDataList.filter(item => item.status === this.selectedStatus)
      }
    },
    getValueClass (item) {
      if (item.status === '高压') return 'high-pressure'
      if (item.status === '低压') return 'low-pressure'
      if (item.status === '正常') return 'normal'
      return 'normal'
    },
    toggleSort () {
      // 检查是否有状态筛选
      if (this.selectedStatus !== '') {
        this.$message.warning('需要显示全部才能排序')
        return
      }

      // 如果当前是排序状态，关闭时需要重新查询
      if (this.isSorting) {
        this.isSorting = false
        this.fetchData()
        console.log('关闭拖动排序，重新查询数据')
      } else {
        this.isSorting = true
        console.log('开启拖动排序')
      }
    },
    // 拖动结束
    onDragEnd () {
      console.log('拖动排序完成:', this.dataList)
      // 保存排序结果
      this.saveSorting()
    },
    // 保存排序结果
    saveSorting () {
      const sortedData = this.dataList.map((item, index) => ({
        ...item,
        serialNumber: index
      }))

      this.$http
        .post('/pipe-network/piezometer/analysis/addSorting', sortedData)
        .then((response) => {
          console.log('排序保存成功:', response)
          this.$message.success('排序保存成功')
        })
        .catch((error) => {
          console.error('排序保存失败:', error)
          this.$message.error('排序保存失败，请重试')
        })
    },
    fetchData () {
      // 根据选择的日期和片区获取数据
      console.log('获取数据 - 时间:', this.selectCollectTime, '片区:', this.zoneNames)

      const params = {
        collectTime: this.selectCollectTime || undefined,
        zoneNames: this.zoneNames.length > 0 ? this.zoneNames : undefined
      }

      // 过滤掉 undefined 的字段
      Object.keys(params).forEach(key => {
        if (params[key] === undefined) {
          delete params[key]
        }
      })

      this.loading = true
      this.$http
        .post('/pipe-network/piezometer/analysis/monitor', params)
        .then(({ data }) => {
          this.obj = {
            normalCount: data.normalCount || 0,
            abnormalCount: data.abnormalCount || 0,
            highPressureCount: data.highPressureCount || 0,
            lowPressureCount: data.lowPressureCount || 0
          }
          // 保存完整数据列表
          this.allDataList = data.items || []
          // 根据当前选中的状态过滤显示
          this.filterDataByStatus()
          console.log('数据获取成功:', this.allDataList)
        })
        .catch((error) => {
          console.error('数据获取失败:', error)
          this.$message.error('数据获取失败，请重试')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.pressure-detection {
  width: 100%;
  height: 120px;
  padding: 10px;
  padding-bottom: 20px;
  border-radius: 10px;
  background-color: white;
}

.header-row {
  display: flex;
  align-items: center;
}

.title-section {
  position: relative;
  display: inline-block;

  .title-bg {
    width: 250px;
    height: 50px;
    object-fit: contain;
  }

  .title-text {
    position: absolute;
    top: 47%;
    left: 27%;
    transform: translate(-50%, -50%);
    color: #093d97;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    z-index: 2;
  }
}

.selection-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  margin-left: 10px;
}

.left-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.right-buttons {
  display: flex;
  gap: 15px;
  align-items: center;
}

.hex-button {
  position: relative;
  width: 120px;
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  .button-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  span {
    font-size: 14px;
    font-weight: 500;
    color: #1890ff;
    z-index: 1;
    position: relative;
  }

  &.active {
    span {
      color: #fff;
    }
  }

}

/* 数据卡片区域样式 */
.data-cards-section {
  height: 630px;
  margin-top: 20px;
  padding: 20px 10px;
  background-color: white;
  border-radius: 10px;
  margin-left: -10px;
  margin-right: -10px;
  width: calc(100% + 20px);
  overflow-y: auto;

  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;

    &:hover {
      background: #a8a8a8;
    }
  }

  /deep/ .ant-spin-container {
    min-height: 500px;
  }

  /deep/ .ant-spin-blur {
    opacity: 0.3;
  }
}

.drag-sort-btn {
  margin-bottom: 15px;
}

.sort-button {
  position: relative;
  width: 120px;
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  .button-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    pointer-events: none;
  }

  span {
    font-size: 14px;
    font-weight: 500;
    color: #1890ff;
    z-index: 1;
    position: relative;
    pointer-events: none;
  }

  &.active {
    span {
      color: #fff;
    }
  }
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
  margin-bottom: 20px;

  .data-card {
    cursor: move;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
}

.data-card {
  background: white;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  position: relative;
}

.card-time {
  font-size: 12px;
  color: #666;
  flex: 1;
}

.card-elevation {
  font-size: 12px;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  margin-left: 10px;
}

.card-bottom {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-location {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #333;
  overflow: hidden;
}

.location-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.card-location span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  margin-bottom: 15px;

  &.normal {
    color: #1890ff;
  }

  &.high-pressure {
    color: #ff7a00;
  }

  &.low-pressure {
    color: #52c41a;
  }
}

.value-number {
  font-size: 28px;
  font-weight: 700;
  color: inherit;
}

.value-unit {
  font-size: 16px;
  font-weight: 700;
  color: inherit;
}

.warning-text {
  font-size: 18px;
  color: #ff4d4f;
  font-weight: 500;
  position: absolute;
  right: 10px;
  top: 30px;
  transform: translateY(-50%);
}

.error-text {
  font-size: 24px;
  color: #ff4d4f;
  font-weight: 700;
}
</style>
